export const FireBaseConfig = {
  apiKey: 'AIzaSyCq267G6pFcom6fal88JCu2_NDL7swK6PU',
  authDomain: 'shop1-8ce4a.firebaseapp.com',
  databaseURL: 'https://shop1-8ce4a.firebaseio.com',
  projectId: '',
  storageBucket: '',
  messagingSenderId: '',
  appId: '',
  measurementId: ''
};
